import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { deviceMax } from '../../theme/breakpoints'
import Button from '../Button/Button'
import Heading from '../Heading/Heading'
import ArrowRight from '../../images/icons/arrow-right-tile.svg'
import ButtonDownload from '../ButtonDownload/ButtonDownload'

export const StyledCard = styled.div`
  flex-direction: row;
  display: flex;
  margin: ${({ $hasMargin }) => ($hasMargin ? `${pxToRem(30)} auto` : '0')};
  border-radius: ${pxToRem(5)};
  width: 100%;
  max-width: ${({ $hasImage }) => ($hasImage ? '100%' : '812px')};
  background-color: ${({ theme, $isPair }) =>
    $isPair ? theme.colors.unique.white : theme.colors.secondary.grey90};

  @media ${deviceMax.mobileL} {
    margin: initial;
    max-width: 384px;
    background-color: ${({ theme }) => theme.colors.unique.white};
    flex-direction: column;
  }

  @media ${deviceMax.mobileM} {
    max-width: initial;
  }
`

export const StyledHeading = styled(Heading)`
  max-width: 100%;
  margin-bottom: ${pxToRem(8)};
`

export const StyledImage = styled.div`
  width: ${pxToRem(270)};
  height: ${pxToRem(220)};
  padding: ${pxToRem(10)};
  flex-shrink: 0;

  @media ${deviceMax.mobileL} {
    width: 100%;
    height: ${pxToRem(180)};
  }

  .normalizedMedia {
    height: 100%;
    width: ${pxToRem(250)};
    object-fit: cover;
    border-radius: ${pxToRem(5)} ${pxToRem(5)} ${pxToRem(30)} ${pxToRem(5)};
    @media ${deviceMax.tablet} {
      width: 100%;
    }
  }
`
export const StyledBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: ${pxToRem(10)};
  margin-left: ${({ $hasImage }) => ($hasImage ? '0' : `${pxToRem(10)}`)};
  width: 100%;
  height: ${pxToRem(210)};
  color: ${({ theme }) => theme.colors.opacity.black70};
  overflow: hidden;
  @media ${deviceMax.tablet} {
    max-width: 100%;
  }
`

export const StyledButtons = styled.div`
  bottom: ${pxToRem(10)};
  right: ${pxToRem(10)};
  display: flex;
  width: 100%;
  flex-basis: auto;
  gap: ${pxToRem(10)};
  justify-content: flex-end;
  @media ${deviceMax.tablet} {
    width: calc(100% - 20px);
  }
  @media ${deviceMax.mobileL} {
    left: ${pxToRem(10)};
    flex-direction: column;
  }
`
export const StyledButton = styled(Button)`
  justify-content: center;
  height: ${pxToRem(50)};
  width: fit-content;
  @media ${deviceMax.mobileL} {
    max-width: 100%;
    width: 100%;
  }
`
export const StyledButtonDownload = styled(ButtonDownload)`
  width: fit-content;
  max-width: 35%;
  @media ${deviceMax.mobileL} {
    max-width: 100%;
    width: 100%;
  }
`

export const StyleIcon = styled(ArrowRight)`
  width: ${pxToRem(18)};
  height: ${pxToRem(18)};
  padding: ${pxToRem(3)} ${pxToRem(3)};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  vertical-align: middle;
`
export const StyledLabel = styled.span`
  margin-right: ${pxToRem(10)};
  text-align: start;
`
